/**
 * @generated SignedSource<<23a16f2bf264398a0063ec7be432efad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BlogListQuery$variables = Record<PropertyKey, never>;
export type BlogListQuery$data = {
  readonly blogs: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly name: string;
      };
      readonly date: any;
      readonly excerpt: string;
      readonly id: string;
      readonly image: string;
      readonly tags: ReadonlyArray<any>;
      readonly title: string;
    } | null | undefined> | null | undefined;
  };
};
export type BlogListQuery = {
  response: BlogListQuery$data;
  variables: BlogListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BlogPostConnection",
    "kind": "LinkedField",
    "name": "blogs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BlogPost",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excerpt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BlogAuthor",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BlogListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3a8061bb23e6ec89bae8cc16e69e2547",
    "id": null,
    "metadata": {},
    "name": "BlogListQuery",
    "operationKind": "query",
    "text": "query BlogListQuery {\n  blogs {\n    nodes {\n      id\n      title\n      excerpt\n      tags\n      date\n      author {\n        name\n      }\n      image\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2411bdba7a07a29e4a8df54a01e0a50";

export default node;
